import React from 'react';
import _ from 'lodash';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { NavLink, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar } from 'antd';
import {
  faCog,
  faUniversity,
  faUser,
  faUsers,
  faHome,
  faSignOut,
  faFileAlt,
  faUpload,
  faHistory,
  faBus,
  faReceipt,
  faTasks,
  faDatabase
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import {
  userAtom,
  tokenAtom,
  userPrivilagesAtom,
  menuSideBarAtom,
  impersonatorAtom
} from '../../../../atoms/Atoms';
import envConfig from '../../../../envConfig';
import analyticsNav from '../../../../analytics/analyticsNav';
import { clearImpersonation } from '../../../../impersonation';

function AuthenticatedSideBar() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [user, setUser] = useRecoilState(userAtom);
  const setToken = useSetRecoilState(tokenAtom);
  const setIsMenuOpen = useSetRecoilState(menuSideBarAtom);
  const setImpersonator = useSetRecoilState(impersonatorAtom);
  const userPrivilages = useRecoilValue(userPrivilagesAtom);

  return (
    <div className="sidebar flex w-full flex-1 flex-col overflow-auto bg-sidebar py-2">
      <NavLink
        to="/profile"
        onClick={() => setIsMenuOpen(false)}
        className={({ isActive }) => `${isActive ? 'bg-sidebarSelected text-sidebarSelectedText font-semibold ' : 'text-sidebarText '}group mx-2 my-0.5 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm tracking-tight transition-colors duration-200 ease-in-out hover:bg-gold-50 hover:text-sidebarSelectedText ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400`}
      >
        {/* <FontAwesomeIcon icon={faUser} />
        <div>{t('profile')}</div> */}
        <Avatar className="bg-primaryColor shrink-0" src={user?.avatar} />
        <div className="truncate font-semibold">{user?.completeName}</div>
      </NavLink>
      <NavLink
        to="/home"
        onClick={() => setIsMenuOpen(false)}
        className={({ isActive }) => `${isActive ? 'bg-sidebarSelected text-sidebarSelectedText font-semibold ' : 'text-sidebarText '}group mx-2 my-0.5 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm tracking-tight transition-colors duration-200 ease-in-out hover:bg-gold-50 hover:text-sidebarSelectedText ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400`}
      >
        <FontAwesomeIcon icon={faHome} />
        <div>{t('home')}</div>
      </NavLink>
      {userPrivilages?.hasGlobalPrivilages && (
        <NavLink
          to="/serverconfig"
          onClick={() => setIsMenuOpen(false)}
          className={({ isActive }) => `${isActive ? 'bg-sidebarSelected text-sidebarSelectedText font-semibold ' : 'text-sidebarText '}group mx-2 my-0.5 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm tracking-tight transition-colors duration-200 ease-in-out hover:bg-gold-50 hover:text-sidebarSelectedText ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400`}
        >
          <FontAwesomeIcon icon={faCog} />
          <div>{t('server_config')}</div>
        </NavLink>
      )}
      {userPrivilages?.hasDataWarehouseHealthPrivilages && (
        <NavLink
          to="/datawarehouse"
          onClick={() => setIsMenuOpen(false)}
          className={({ isActive }) => `${isActive ? 'bg-sidebarSelected text-sidebarSelectedText font-semibold ' : 'text-sidebarText '}group mx-2 my-0.5 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm tracking-tight transition-colors duration-200 ease-in-out hover:bg-gold-50 hover:text-sidebarSelectedText ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400`}
        >
          <FontAwesomeIcon icon={faDatabase} />
          <div>{t('data_warehouse')}</div>
        </NavLink>
      )}
      {userPrivilages?.hasAdminPrivilages && (
        <NavLink
          to="/corporations"
          onClick={() => setIsMenuOpen(false)}
          className={({ isActive }) => `${isActive ? 'bg-sidebarSelected text-sidebarSelectedText font-semibold ' : 'text-sidebarText '}group mx-2 my-0.5 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm tracking-tight transition-colors duration-200 ease-in-out hover:bg-gold-50 hover:text-sidebarSelectedText ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400`}
        >
          <FontAwesomeIcon icon={faUniversity} />
          <div>{t('corporations')}</div>
        </NavLink>
      )}
      {userPrivilages?.hasCustomerSupportPrivilages && (
        <NavLink
          to="/users"
          onClick={() => setIsMenuOpen(false)}
          className={({ isActive }) => `${isActive ? 'bg-sidebarSelected text-sidebarSelectedText font-semibold ' : 'text-sidebarText '}group mx-2 my-0.5 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm tracking-tight transition-colors duration-200 ease-in-out hover:bg-gold-50 hover:text-sidebarSelectedText ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400`}
        >
          <FontAwesomeIcon icon={faUsers} />
          <div>{t('users')}</div>
        </NavLink>
      )}
      {/* <NavLink
        to="/comparisons"
        onClick={() => setIsMenuOpen(false)}
        className={({ isActive }) => `${isActive ? 'bg-sidebarSelected text-sidebarSelectedText font-semibold ' : 'text-sidebarText '}group mx-2 my-0.5 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm tracking-tight transition-colors duration-200 ease-in-out hover:bg-gold-50 hover:text-sidebarSelectedText ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400`}
      >
        <FontAwesomeIcon icon={faDatabase} />
        <div>{t('data_comparisons')}</div>
      </NavLink>
      <NavLink
        to="/categorycomparison"
        onClick={() => setIsMenuOpen(false)}
        className={({ isActive }) => `${isActive ? 'bg-sidebarSelected text-sidebarSelectedText font-semibold ' : 'text-sidebarText '}group mx-2 my-0.5 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm tracking-tight transition-colors duration-200 ease-in-out hover:bg-gold-50 hover:text-sidebarSelectedText ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400`}
      >
        <FontAwesomeIcon icon={faDatabase} />
        <div>{t('category_comparison')}</div>
      </NavLink>
      <NavLink
        to="/taxcomparison"
        onClick={() => setIsMenuOpen(false)}
        className={({ isActive }) => `${isActive ? 'bg-sidebarSelected text-sidebarSelectedText font-semibold ' : 'text-sidebarText '}group mx-2 my-0.5 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm tracking-tight transition-colors duration-200 ease-in-out hover:bg-gold-50 hover:text-sidebarSelectedText ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400`}
      >
        <FontAwesomeIcon icon={faDatabase} />
        <div>{t('tax_comparison')}</div>
      </NavLink> */}
      <NavLink
        to="/summary/salesshirkage"
        onClick={() => setIsMenuOpen(false)}
        className={({ isActive }) => `${isActive ? 'bg-sidebarSelected text-sidebarSelectedText font-semibold ' : 'text-sidebarText '}group mx-2 my-0.5 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm tracking-tight transition-colors duration-200 ease-in-out hover:bg-gold-50 hover:text-sidebarSelectedText ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400`}
      >
        <FontAwesomeIcon icon={faTasks} />
        <div>{t('daily_movement')}</div>
      </NavLink>
      {/* <NavLink
        to="/summary/sales/daily"
        onClick={() => setIsMenuOpen(false)}
        className={({ isActive }) => `${isActive ? 'bg-sidebarSelected text-sidebarSelectedText font-semibold ' : 'text-sidebarText '}group mx-2 my-0.5 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm tracking-tight transition-colors duration-200 ease-in-out hover:bg-gold-50 hover:text-sidebarSelectedText ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400`}
      >
        <FontAwesomeIcon icon={faTasks} />
        <div>{t('sales_daily_summary_window')}</div>
      </NavLink> */}
      <NavLink
        to="/summary/sales/weekly"
        onClick={() => setIsMenuOpen(false)}
        className={({ isActive }) => `${isActive ? 'bg-sidebarSelected text-sidebarSelectedText font-semibold ' : 'text-sidebarText '}group mx-2 my-0.5 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm tracking-tight transition-colors duration-200 ease-in-out hover:bg-gold-50 hover:text-sidebarSelectedText ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400`}
      >
        <FontAwesomeIcon icon={faTasks} />
        <div>{t('sales_summary_window')}</div>
      </NavLink>
      {/* <NavLink
        to="/summary/sales/clover"
        onClick={() => setIsMenuOpen(false)}
        className={({ isActive }) => `${isActive ? 'bg-sidebarSelected text-sidebarSelectedText font-semibold ' : 'text-sidebarText '}group mx-2 my-0.5 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm tracking-tight transition-colors duration-200 ease-in-out hover:bg-gold-50 hover:text-sidebarSelectedText ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400`}
      >
        <FontAwesomeIcon icon={faTasks} />
        <div>{t('clover_sales_summary')}</div>
      </NavLink> */}
      {/* <NavLink
        to="/summary/salesshirkage/clover"
        onClick={() => setIsMenuOpen(false)}
        className={({ isActive }) => `${isActive ? 'bg-sidebarSelected text-sidebarSelectedText font-semibold ' : 'text-sidebarText '}group mx-2 my-0.5 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm tracking-tight transition-colors duration-200 ease-in-out hover:bg-gold-50 hover:text-sidebarSelectedText ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400`}
      >
        <FontAwesomeIcon icon={faTasks} />
        <div>{t('weekly_merma_summary')}</div>
      </NavLink> */}

      {/* Merchandising analytics -- the analytics role (GlobalAdmin, Admin or
          Analytics). The API enforces the same set. */}
      {userPrivilages?.hasAnalyticsPrivilages && (
        <>
          <div className="mx-4 mt-3 mb-1 border-t border-line pt-3 text-[11px] font-semibold uppercase tracking-wide text-muted">
            {t('analytics_section')}
          </div>
          {analyticsNav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setIsMenuOpen(false)}
              className={({ isActive }) => `${isActive ? 'bg-sidebarSelected text-sidebarSelectedText font-semibold ' : 'text-sidebarText '}group mx-2 my-0.5 flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm tracking-tight transition-colors duration-200 ease-in-out hover:bg-gold-50 hover:text-sidebarSelectedText ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400`}
            >
              <FontAwesomeIcon icon={item.icon} />
              <div>{t(item.label)}</div>
            </NavLink>
          ))}
        </>
      )}

      <div className="mx-2 mt-3 border-t border-line pt-3">
        <button
          type="button"
          className="flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-danger transition-colors duration-200 ease-in-out hover:bg-rose-50 ring-0 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-300"
          onClick={() => {
            const promise = new Promise(function (resolve, reject) {
              setIsMenuOpen(false);
              window.localStorage.removeItem(`${envConfig.StoragePrefix}-user`);
              window.localStorage.removeItem(`${envConfig.StoragePrefix}-token`);
              clearImpersonation();
              setImpersonator(null);
              setToken(null);
              resolve();
            });
            promise.then(() => {
              setUser(null);
            })
            .then(() => {
              navigate('/');
            });
          }}
        >
          <FontAwesomeIcon icon={faSignOut} />
          {t('sign_out')}
        </button>
      </div>
    </div>
  );
}

export default AuthenticatedSideBar;
